# import { default as WebModule__Content } from 'models/modulor/web_module/content'
#
# export class GroupPortrait extends WebModule__Content
#   @defaults =
#     debug: false
#     name: 'GroupPortraitModule'
#
#   @selector: ".group_portrait_module"
#
#   on_init: ->
#     console.log 'init' if @options.debug
#
# GroupPortrait.register()
